module.exports = __webpack_public_path__ + "img/Flag_of_Japan.ac5b479c.svg";